// extracted by mini-css-extract-plugin
module.exports = {"CustomDropdown":"CustomDropdown_CustomDropdown__2OVbG"};